import React, {useRef} from 'react';
import styles from "./styles.module.scss";
import useTranslation from "next-translate/useTranslation";
import {Autoplay, Navigation, Pagination} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react";
import cn from "classnames";
import BtnPrev from "../../../common/components/Icons/Common/BtnPrev";
import BtnNext from "../../../common/components/Icons/Common/BtnNext";
import _1Img from "/public/aboutUs/aboutInfo/_1.png";
import _2Img from "/public/aboutUs/aboutInfo/_2.png";
import _3Img from "/public/aboutUs/aboutInfo/_3.png";
import _4Img from "/public/aboutUs/aboutInfo/_4.png";
import _5Img from "/public/aboutUs/aboutInfo/_5.png";
import _6Img from "/public/aboutUs/aboutInfo/_6.png";
import _7Img from "/public/aboutUs/aboutInfo/_7.png";
import _8Img from "/public/aboutUs/aboutInfo/_8.png";
import imgMobile from "/public/aboutUs/aboutInfo/mobile.png";
import Image from "next/image";
import {ABOUT_NAMESPACE} from "../../../../utils/i18nNameSpaces";

const imgs = [
  _1Img,
  _2Img,
  _3Img,
  _4Img,
  _5Img,
  _6Img,
  _7Img,
  _8Img
]

const Index = () => {
  const {t} = useTranslation(ABOUT_NAMESPACE);
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  return (
    <section className={styles["about"]}>
      <div className={styles["container"]}>
        <div className={styles["img--mobile"]}>
          <Image src={imgMobile} quality={100} layout="responsive"/>
        </div>
        <div className={styles["content"]}>
          <p className={styles["subhead"]}>{t("aboutInfo.subhead")}</p>
          <h3 className={styles["header"]}>{t("aboutInfo.header")}</h3>
          <p className={styles["subheader"]}>{t("aboutInfo.subheader")}</p>
        </div>
        <div className={styles["slider-wrapper"]}>
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            pagination={{
              clickable: true,
            }}
            lazy={{
                loadPrevNext: true,
                loadPrevNextAmount: 2
            }}
            slidesPerView={1}
            spaceBetween={30}
            autoplay={{
              delay: 5000,
              pauseOnMouseEnter: true,
              disableOnInteraction: false
            }}
            navigation={{
              prevEl: navigationPrevRef.current,
              nextEl: navigationNextRef.current,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = navigationPrevRef.current;
              swiper.params.navigation.nextEl = navigationNextRef.current;
            }}
          >
            {imgs.map((el, i) => (
              <SwiperSlide key={i}>
                <div className={styles["slide-container"]}>
                  <Image src={el} quality={100} layout="responsive" priority={true}/>
                </div>
              </SwiperSlide>
            ))}
            <div ref={navigationPrevRef} className={cn(styles["nav-btn"], styles["nav-btn--prev"])}>
              <BtnPrev/>
            </div>
            <div ref={navigationNextRef} className={cn(styles["nav-btn"], styles["nav-btn--next"])}>
              <BtnNext/>
            </div>
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Index;